class MarketAnalysisService {
    lastError;
    lastResponseCode;

    constructor(axios) {
        this.axios = axios
    }
    async getMarketSummaryByDate(date, lang) {
        const url = '/api/market/report/archive'
        const params = {
            date,
            lang,
        }
        return await this.axios
            .get(url, { params })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getLastMarketSummary(lang) {
        const url = '/api/market/report/last'
        const params = {
            lang,
        }
        return await this.axios
            .get(url, { params })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getPersonalizedMarketSummary(lang, cancelToken) {
        const url = `/api/market/report/personalized?lang=${lang}`
        
        return await this.axios
            .get(url, { cancelToken })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getMarketPerformance() {
        const url = '/api/market/report/performance'

        return await this.axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getKpiCardsConfiguration() {
        const url = '/api/account/config/market_analysis_widget_configuration'

        return await this.axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async updateKpiCardsConfiguration(dataToUpdate) {
        const url = '/api/account/config/market_analysis_widget_configuration'

        return await this.axios
            .put(url, { value: dataToUpdate })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getFearAndGreed() {
        const url = '/api/market/report/widget/fearandgreed'

        return await this.axios
            .get(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async getFAQ(cancelToken, lang) {
        const url = `/api/faqs?lang=${lang}`

        return await this.axios
            .get(url, { cancelToken: cancelToken })
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
    }

    async likeFAQ(id) {
        const url = `/api/faq/${id}/like`

        return await this.axios
            .put(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    async dislikeFAQ(id) {
        const url = `/api/faq/${id}/dislike`

        return await this.axios
            .put(url)
            .then((res) => {
                this.lastResponseCode = res.status
                return res.data
            })
            .catch((error) => {
                return this.handleError(error)
            })
    }

    handleError(e) {
        console.log(e)

        this.lastResponseCode = e.response?.status
        this.lastError = e.response?.statusText

        throw new Error(this.lastError)
    }
}

export default MarketAnalysisService
